import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext } from 'preact/compat';
import { OptionsCTX } from '@siteSearch/context/Options';
import { useCallback } from 'react';
import SearchField from '@siteSearch/components/SearchField';
function SearchHeader({ handleSubmit }) {
    const { backButton, formAction } = useContext(OptionsCTX);
    const handleBackButton = useCallback(() => {
        if (backButton.link) {
            window.location.href = backButton.link;
            return;
        }
        window.history.back();
    }, [backButton]);
    return (_jsxs("header", { className: "header", id: "search-header", children: [_jsx("div", { className: "background" }), _jsx("div", { className: "container container--small", children: _jsx("div", { id: "page-header__inner", children: _jsx("form", { action: formAction ?? '', method: "GET", noValidate: true, onSubmit: handleSubmit, role: "search", className: "search-bar", children: _jsx(SearchField, { name: "search" }) }) }) })] }));
}
export default SearchHeader;
